export const WHERE_WE_FLY_URL =
	'https://houston.wherewefly.com/?share=https://fly2houston.com/iah/explore-destinations/&override=yes';
